export default "__VITE_ASSET__DzKIWiYs__"